import React from "react";

export default function SQL_ROWNUM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ROWNUM</h1>
      <p>This is the SQL_ROWNUM component generated from the SQL JSON.</p>
    </div>
  );
}
